// extracted by mini-css-extract-plugin
export default {"dropdown":"roles_actions-module___dropdown___d531a9e0","dangerButton":"roles_actions-module___dangerButton___da1e4ed8"};